import i18n from "@/language/i18n";
import ACTIVITY_WIDGETS from "../widgets/ACTIVITY_WIDGETS";

const ACTIVITY_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    ACTIVITY_MODULE_WINDOW_ID: 'activities',
    TRANSACTION_MODULE_WINDOW_ID: 'stockmovements',
    EMAILS_MODULE_WINDOW_ID: 'emails',
});

export { ACTIVITY_MODULE_WINDOW_IDENTIFIER };

export default {
    ACTIVITY_GROUP_WRAPPER: {
        type: 'group',
        id: 'activity',
        label: i18n.t('ModuleRegistry.groups.activityManagement.name'),
        children: [],
        icon: '$wCircle',
        sidebarIcon: '$wNavActivities'
    },
    CHILDREN: {
        ACTIVITIES_MODULE: {
            type: 'module',
            id: 'activities',
            windowIdentifierType: ACTIVITY_MODULE_WINDOW_IDENTIFIER.ACTIVITY_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.activityManagement.name'),
            navigationImg: require('@/assets/navigation/items/icon_kontakte.svg'),
            routerLink: '/activities',
            globalSearch: {
                index: 'activities',
                presentation: i18n.t('ModuleRegistry.groups.activityManagement.name'),
                component: 'ActivityItem.vue',
                shortcut: '-a'
            },
            widgets: ACTIVITY_WIDGETS.ACTIVITY_WIDGETS
        },
        EMAIL_MODULE: {
            type: 'module',
            id: 'emails',
            windowIdentifierType: ACTIVITY_MODULE_WINDOW_IDENTIFIER.EMAILS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.activityManagement.emails.label'),
            navigationImg: require('@/assets/navigation/items/icon_zeiterfassung.svg'),
            routerLink: '/emails',
            widgets: ACTIVITY_WIDGETS.EMAILS_WIDGETS
        },
    }
}
